import { getApiAuthToken } from "#auth/api-token";

import type { CreateClientConfig } from "./api/client.gen";
import { normalizeApiErrorResponse } from "./apiError";
import { getDevelopmentProxyApiUrl, getPbApiUrl } from "./apiFetch/url";

function getApiUrl() {
  if (
    process.env.NODE_ENV === "development" &&
    process.env.NEXT_PUBLIC_IS_E2E !== "true"
  ) {
    return getDevelopmentProxyApiUrl();
  }

  return getPbApiUrl();
}

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  credentials: "include",
  baseUrl: getApiUrl(),
  async fetch(request, options) {
    const token = await getApiAuthToken();
    if (
      token &&
      options?.headers instanceof Headers &&
      !options.headers.has("Authorization")
    ) {
      options.headers.set("Authorization", `Bearer ${token}`);
    }

    const response = await fetch(request, options);
    return normalizeApiErrorResponse({
      request,
      requestOptions: options,
      response,
    });
  },
});
